var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":_vm.size,"height":_vm.size,"viewBox":"0 0 24 24","fill":"currentColor","aria-hidden":"true"}},[_c('path',{attrs:{"d":"M2.5 12.5 21 4l-7.5 16.5-2-7.5-9-.5z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }